// orders.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_ORDERS,
  MERGE_ORDER_DATA,
  SET_ORDER_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
  RESTORE_ORDER_DATA,
  CLEAR_ORDER_DATA,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Orders.
 * @module reducer/orders
 */
const orders = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_ORDERS:
      return _ADD_ORDERS(action.payload)(state);
    case MERGE_ORDER_DATA:
      return _MERGE_ORDER_DATA(action.payload)(state);
    case SET_ORDER_DATA:
      return _SET_ORDER_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    case RESTORE_ORDER_DATA:
      return _RESTORE_ORDER_DATA(action.payload)(state);
    case CLEAR_ORDER_DATA:
      return _CLEAR_ORDER_DATA(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add orders
 * @kind reducer/actionType
 * @name ADD_ORDERS
 * @param {object} {orders} - orders object using id as keys
 * @return {Immutable.Map} New state
 */
const _ADD_ORDERS =
  ({ orders }) =>
  state => {
    return state.mergeDeep(orders);
  };

/**
 * Merge order data
 * @kind reducer/actionType
 * @name MERGE_ORDER_DATA
 * @param {object} {order} - order object
 * @param {object} {order.id} - order id
 * @return {Immutable.Map} New state
 */
const _MERGE_ORDER_DATA =
  ({ order }) =>
  state => {
    return state.mergeDeepIn([order.id], order);
  };

/**
 * Set order data
 * @kind reducer/actionType
 * @name SET_ORDER_DATA
 * @param {object} payload - action payload.
 * @param {array} payload.selectPath - select path.
 * @param {object} payload.data - data.
 * @return {Immutable.Map} New state
 */
const _SET_ORDER_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.setIn(selectPath, fromJS(data));
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

/**
 * Restore order data
 * @kind reducer/actionType
 * @name RESTORE_ORDER_DATA
 * @param {object} orderData - order data
 * @return {Immutable.Map} New state
 */
const _RESTORE_ORDER_DATA = orderData => state => {
  return state.mergeDeep(orderData);
};

/**
 * Clear order data
 * @kind reducer/actionType
 * @name CLEAR_ORDER_DATA
 * @return {Immutable.Map} New state
 */
const _CLEAR_ORDER_DATA = () => () => {
  return defaultState;
};

export default orders;
